import request from '@/common/request/request_product'
import gSetting from '@/common/setting/index'
const apiUrl = gSetting.common.apiUrl;

function appointmentCreate(data) { return request({ url: '/Appointment/Create', method: 'post', data, baseURL: apiUrl }) }

function tenantAppMarketGetList(data) { return request({ url: '/Tenant/AppMarketGetList', method: 'get', data }) }

function register(data) { return request({ url: '/Tenant/Register', method: 'post', data, baseURL: apiUrl }) }
function verifyCodeSend(data) { return request({ url: '/VerifyCode/Send', method: 'post', data, baseURL: apiUrl }) }




export default {
  appointmentCreate,
  tenantAppMarketGetList,
  register,
  verifyCodeSend
}